import Api from '../baseApi';

export default {
  async create(data) {
    return await Api.put('/api-article/v1/testPig', data);
  },
  createFromCarcase(form) {
    return Api.post(`/api-article/v1/testPig/create-from-carcase`, form);
  },
  async update(id, data) {
    return await Api.post(`/api-article/v1/testPig/${id}`, data);
  },
  async delete(id) {
    return await Api.delete(`/api-article/v1/testPig/${id}`);
  },
  async fetch() {
    return await Api.get(`/api-article/v1/testPig`);
  }
}
